import { ActivatedRoute } from "@angular/router";
export class InspectionDetailsBase {
  public inspectionId: string = null;

  constructor(protected route: ActivatedRoute) {
    this.inspectionId =
      this.route.snapshot.params?.id ??
      this.route.snapshot.parent.paramMap.get("id");
  }
}
